
import React from 'react'
import {Sun, Moon} from 'lucide-react'
import { motion } from 'framer-motion'
import { useTheme } from '../hooks/useTheme'

const ThemeToggle: React.FC = () => {
  const { theme, toggleTheme } = useTheme()

  return (
    <button
      onClick={toggleTheme}
      className="relative w-12 h-6 rounded-full bg-gray-200 dark:bg-gray-700 transition-colors duration-300 focus:outline-none focus:ring-2 focus:ring-gray-400 focus:ring-opacity-50"
      aria-label="Toggle theme"
    >
      {/* 滑動球 */}
      <motion.div
        className="absolute top-0.5 w-5 h-5 bg-white dark:bg-gray-800 rounded-full shadow-md flex items-center justify-center"
        animate={{
          x: theme === 'dark' ? 24 : 2
        }}
        transition={{
          type: "spring",
          stiffness: 500,
          damping: 30
        }}
      >
        {/* 圖標 */}
        <motion.div
          initial={false}
          animate={{
            scale: 1,
            rotate: theme === 'dark' ? 180 : 0
          }}
          transition={{
            duration: 0.3
          }}
        >
          {theme === 'light' ? (
            <Sun size={12} className="text-yellow-500" />
          ) : (
            <Moon size={12} className="text-blue-400" />
          )}
        </motion.div>
      </motion.div>
      
      {/* 背景圖標 */}
      <div className="absolute inset-0 flex items-center justify-between px-1.5">
        <Sun size={10} className="text-yellow-400 opacity-60" />
        <Moon size={10} className="text-blue-400 opacity-60" />
      </div>
    </button>
  )
}

export default ThemeToggle
